import { IQuestionMentorFeedback } from 'app/shared/model/question-mentor-feedback.model';
import { IUser } from 'app/shared/model/user.model';
import { IConnection } from 'app/shared/model/connection.model';

export interface IQuestion {
  id?: number;
  question?: string | null;
  questionMentorFeedbacks?: IQuestionMentorFeedback[] | null;
  user?: IUser | null;
  connections?: IConnection[] | null;
}

export const defaultValue: Readonly<IQuestion> = {};
